import CurrentChapterCard from "./CurrentChapterCard";

export default CurrentChapterCard;
